// PreviousRouteContext.tsx
import { createContext, PropsWithChildren, useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

type PreviousRouteContextType = {
    previousRoute: string | null;
    clearPreviousRoute: () => void;
    emailFromUrl: string;
    emailSetter: (email: string) => void
};

const PreviousRouteContext = createContext<PreviousRouteContextType | undefined>(undefined);

export const PreviousRouteProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const location = useLocation();
    const [previousRoute, setPreviousRoute] = useState<string | null>(null);
    const [emailFromUrl, setEmailFromUrl] = useState<string>('');
    const currentPathRef = useRef(location.pathname);

    useEffect(() => {
        setPreviousRoute(currentPathRef.current);
        currentPathRef.current = location.pathname;
    }, [location]);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const emailParam = queryParams.get('email');
        setEmailFromUrl(emailParam || '');
    }, [location.search]);

    const clearPreviousRoute = () => {
        setPreviousRoute(null);
    };

    const emailSetter = (email: string) => {
        setEmailFromUrl(email)
    }

    return (
        <PreviousRouteContext.Provider value={{ previousRoute, clearPreviousRoute, emailFromUrl, emailSetter }}>
            {children}
        </PreviousRouteContext.Provider>
    );
};

export const usePreviousRoute = () => {
    const context = useContext(PreviousRouteContext);
    if (!context) {
        throw new Error('usePreviousRoute must be used within PreviousRouteProvider');
    }
    return context;
};
